import { createAsyncThunk, createSlice } from "@reduxjs/toolkit"
import axios from "../../../config/authAxios"



const initialState = { status: null, loading: false, data: [], error: "", message: "" }


export const getSingleCategoryAction = createAsyncThunk(
    'get-single-category',
    async (data = null, { rejectWithValue }) => {
        try {
            const res = await axios.get(`/support-server/api/get-single-category/${data}`)
            return res?.data
        } catch (error) {
            return rejectWithValue(error.response.data)
        }
    }
)


export const getSingleCategorySlice = createSlice({
    name: 'get-single-category',
    initialState,
    reducers: {},
    extraReducers:
        (builder) => {
            builder.addCase(getSingleCategoryAction.pending, (state) => {
                state.loading = true
            })
            builder.addCase(getSingleCategoryAction.fulfilled, (state, action) => {
                state.loading = false
                state.data = action?.payload?.data
                state.status = action?.payload?.status
                state.message = action?.payload?.message
            })
            builder.addCase(getSingleCategoryAction.rejected, (state, action) => {
                state.loading = false
                state.error = action?.payload?.error
                state.status = action?.payload?.status
                state.message = action?.payload?.message
            })
        },

})



export const getSingleCategoryReducer = getSingleCategorySlice.reducer    